// extracted by mini-css-extract-plugin
export var borderRadius = "_c5-4";
export var large = "_c5-3";
export var logoContainer = "_c5-0";
export var nameLogo = "_c5-2";
export var small = "_c5-1";